/**
 * 영상 소개 샘플 (BOOTH-60 1b-2, 캔버스 9.1 "움직이는 화보" 화면의 9:16 루프).
 * 운영자가 콘솔에서 올린 MP4 를 부스 기본값 또는 테마별로 둔다. 키오스크는 테마 샘플 → 없으면 부스 샘플 → 둘 다 없으면 손님의 변환 사진을 프레임에 대신 보여준다.
 * 파일은 저장소 `v/samples/{boothId}/{nanoid}.{ext}` (기존 `/v/*` CloudFront 경로, 영구 보관). 교체·제거 시 서버가 이전 객체를 지운다.
 */
/** 업로드 상한 — 5초 9:16 H.264 는 보통 2~5MB. presigned PUT 이라 Lambda 6MB 한도와 무관하지만 매장 Wi-Fi 를 생각해 30MB. */
export const SAMPLE_VIDEO_MAX_BYTES = 30 * 1024 * 1024;
/** 허용 MIME → 확장자. iPad Safari 는 셋 다 재생하지만 데스크톱 Chrome 콘솔 미리보기는 quicktime 을 못 틀 수 있어 MP4 권장. */
export const SAMPLE_VIDEO_MIME_EXT = {
    "video/mp4": "mp4",
    "video/webm": "webm",
    "video/quicktime": "mov",
};
export function sampleVideoExt(mime) {
    return SAMPLE_VIDEO_MIME_EXT[mime.toLowerCase()] ?? null;
}
export const SAMPLE_VIDEO_KEY_PREFIX = "v/samples/";
/** 키오스크 영상 소개 화면이 틀 샘플 — 테마 샘플이 우선, 없으면 부스 기본, 둘 다 없으면 null(손님 사진으로 대체). 빈 문자열 = 없음. */
export function resolveSampleVideoUrl(theme, booth) {
    return theme?.sampleVideoUrl || booth?.sampleVideoUrl || null;
}
//# sourceMappingURL=sample-video.js.map